(function() {
  function initVideoSlider() {
    if (typeof Splide === 'undefined') return;
    document.querySelectorAll('.slide-con:not(.is-initialized)').forEach(function(el) {
      new Splide(el, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: 24,
        pagination: false,
        autoplay: true,
        padding: 0,
        breakpoints: {
          1024: { perPage: 3, perMove: 1, rewind: true, padding: 0, autoplay: true, gap: 36 },
          767: { perPage: 2, perMove: 1, rewind: true, padding: '4rem', focus: 'center', autoplay: true, gap: 20 },
          500: { perPage: 2, perMove: 1, rewind: true, padding: '4rem', focus: 'center', autoplay: true, gap: 14, arrows: false }
        }
      }).mount();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoSlider);
  } else {
    initVideoSlider();
  }
})();
